import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/image_apple_appstore.png")